import { Button, Divider, Spin } from "antd";
import { useContext, useEffect, useRef, useState } from "react";
import { Link, useParams, useSearchParams } from "react-router-dom";
import BreadCrumb from "../../Components/BreadCrumb/BreadCrumb";
import Layout from "../../Components/Layout/Layout";
import { CartContext } from "../../Contexts/CartContext";
import axios from "../../config/axios";
import moment from "../../config/moment";
import styles from "./OrderSuccess.module.scss";

const OrderSuccess = (props) => {
  const [order, setOrder] = useState({});
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const { emptyCart } = useContext(CartContext);
  // emptyCart is re-created on every CartContext render, so it can't go in the
  // effect deps without re-running it; a ref keeps the clear to exactly once.
  const cartCleared = useRef(false);

  useEffect(() => {
    (async () => {
      await axios.post(`/orders/verify/${searchParams.get("payment_intent")}`, {});
      let res_order = await axios.get(`/orders/${id}`);
      setOrder(res_order.data);
      console.log(res_order.data);
      setLoading(false);

      // The order is on record now, so the cart it came from is stale. Stripe
      // sends the customer back here with redirect_status=failed when a
      // redirect-based payment method declines — they still need their items
      // in that case, so leave the cart alone.
      if (
        !cartCleared.current &&
        searchParams.get("redirect_status") !== "failed"
      ) {
        cartCleared.current = true;
        emptyCart();
      }
    })();
  }, [id, searchParams]);

  const downloadInvoice = () => {
    axios
      .get(`/orders/invoice/${order.id}`, {
        withCredentials: true,
        responseType: "arraybuffer",
      })
      .then((response) => {
        // console.log(response.data);
        const url = window.URL.createObjectURL(
          new Blob([response.data], { type: "application/pdf" }),
        );
        // console.log(url);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `DesiFreshInvoice-${order.id}.pdf`); //or any other extension
        document.body.appendChild(link);
        link.click();
      })
      .finally(() => {
        // setExcelLoading(false);
      });
  };

  return (
    <Layout>
      <div className={styles.order_success_wrapper}>
        {loading ? (
          <div className={styles.center_loading}>
            <Spin />
          </div>
        ) : (
          <>
            {error ? (
              <div className={styles.center_loading}>
                <p> No Data Found!</p>
              </div>
            ) : (
              <>
                <div style={{ marginInline: 20 }}>
                  <BreadCrumb
                    list={[
                      { name: "Home", link: "/" },
                      {
                        name: "My Cart",
                        link: "/cart",
                      },
                      {
                        name: "Shipping Address",
                      },
                      {
                        name: "Payment Method",
                      },
                      {
                        name: "Review  & Confirm",
                      },
                      {
                        name: "Confirmation",
                      },
                    ]}
                  />
                </div>
                <br />
                <div className={styles.order_success_container}>
                  <img
                    src={
                      "https://desi-fresh.b-cdn.net/components_static/Orders/check-circle_outline.svg"
                    }
                    alt="check_box"
                    className={styles.check_box}
                  />
                  <h3 className={styles.order_successful}>Confirmation</h3>
                  <img
                    src={
                      "https://desi-fresh.b-cdn.net/components_static/Orders/desi_box.svg"
                    }
                    alt="desi_delivery_box"
                    className={styles.desi_delivery_box}
                  />
                  <div className={styles.thank_you}>
                    <h3>
                      Hey Mr. {order.first_name} {order.last_name}{" "}
                    </h3>
                    <div className={styles.order_received}>
                      <img
                        src="https://desi-fresh.b-cdn.net/components_static/Orders/happy_face.svg"
                        alt="happy_face"
                      />
                      <h3>
                        {order.payment_status === "pending"
                          ? "Order received, Thank you!"
                          : "Your order was successful"}
                      </h3>
                    </div>
                  </div>

                  <h4>
                    <strong>
                      {order.payment_status === "paid" &&
                        "Thank you! we have received your order"}
                    </strong>
                  </h4>

                  {order.payment_status === "pending" && (
                    <div style={{ textAlign: "center" }}>
                      To ensure prompt processing, kindly transfer{" "}
                      <strong>
                        {" "}
                        <u>{order.total}€</u>{" "}
                      </strong>{" "}
                      to proceed with your order. Once received, we'll send the
                      tracking link. Please note, failure to pay within 7 days
                      will result in order deletion. Thank you.
                    </div>
                  )}
                  {order.payment_status === "paid" && (
                    <div style={{ textAlign: "center" }}>
                      Thank you for your order and for joining us in supporting
                      underprivileged children through{" "}
                      <a
                        href="/"
                        style={{
                          color: "var(--color-primary)",
                          textDecoration: "underline",
                        }}
                      >
                        Desi Hands.
                      </a>{" "}
                      You can now sit back and relax as we prepare and deliver
                      your order with care. We appreciate your contribution
                      towards this meaningful cause and hope you enjoy your
                      purchase. A confirmation has been sent on your registered
                      email or phone number.
                    </div>
                  )}

                  {order.payment_status === "paid" && (
                    <div className={styles.payment_done}>
                      <img
                        src="https://desi-fresh.b-cdn.net/components_static/Orders/check.svg"
                        alt="check"
                      />
                      <p> Payment done successfully </p>
                    </div>
                  )}

                  {/*<a*/}
                  {/*  href={`/order/invoice?invoiceID=${id}&print=true`}*/}
                  {/*  target='_blank'*/}
                  {/*  rel='noreferrer'*/}
                  {/*>*/}
                  <Button
                    className={styles.download_invoice}
                    onClick={downloadInvoice}
                  >
                    <p>Download Invoice</p>
                    <img
                      src="https://desi-fresh.b-cdn.net/components_static/Orders/download.svg"
                      alt="download"
                    />
                  </Button>
                  {/*</a>*/}

                  <div style={{ width: "100%" }}>
                    <h3
                      style={{
                        margin: 0,
                        color: "var(--color-primary)",
                        fontWeight: "700",
                      }}
                    >
                      Order Details
                    </h3>
                    <Divider style={{ margin: "0 0 8px 0" }} />
                    <div className={styles.order_description}>
                      <div className={styles.order_description_option}>
                        Order Nr.
                      </div>
                      <div className={styles.order_description_value}>
                        {" "}
                        {order.id}{" "}
                      </div>
                    </div>

                    {/*<div className={styles.order_description}>*/}
                    {/*  <div className={styles.order_description_option}>Customer Nr.</div>*/}
                    {/*  <div className={styles.order_description_value}> 2441139 </div>*/}
                    {/*</div>*/}

                    <div className={styles.order_description}>
                      <div className={styles.order_description_option}>
                        Order date
                      </div>
                      <div className={styles.order_description_value}>
                        {" "}
                        {moment(order.timestamp).format("DD.MM.YY")}{" "}
                      </div>
                    </div>

                    <div className={styles.order_description}>
                      <div className={styles.order_description_option}>
                        Delivery by
                      </div>
                      <div className={styles.order_description_value}>
                        {" "}
                        Desi Fresh
                      </div>
                    </div>

                    <div className={styles.order_description}>
                      <div className={styles.order_description_option}>
                        Delivery to
                      </div>
                      <div className={styles.order_description_value}>
                        {" "}
                        {order.title} {order.first_name} {order.last_name}{" "}
                      </div>
                    </div>

                    <div className={styles.order_description}>
                      <div className={styles.order_description_option}>
                        Delivery address
                      </div>
                      <div
                        className={styles.order_description_value}
                        style={{ textTransform: "capitalize" }}
                      >
                        {order.street_address}, {order.house_no},{" "}
                        {order.zip_code}
                        <br />
                        {order.city}, {order.country}
                      </div>
                    </div>
                  </div>

                  <div style={{ width: "100%", marginTop: 10 }}>
                    <h3
                      style={{
                        margin: 0,
                        color: "var(--color-primary)",
                        fontWeight: "700",
                      }}
                    >
                      Payment Details
                    </h3>
                    <Divider style={{ margin: "0 0 8px 0" }} />
                    {order.payment_status === "pending" && (
                      <>
                        <div className={styles.order_description}>
                          <div className={styles.order_description_option}>
                            Payee
                          </div>
                          <div className={styles.order_description_value}>
                            {" "}
                            Desi Fresh
                          </div>
                        </div>

                        <div className={styles.order_description}>
                          <div className={styles.order_description_option}>
                            Bank name
                          </div>
                          <div className={styles.order_description_value}>
                            {" "}
                            Deutsche Bank
                          </div>
                        </div>

                        <div className={styles.order_description}>
                          <div className={styles.order_description_option}>
                            IBAN
                          </div>
                          <div className={styles.order_description_value}>
                            DE1770070024089627300
                          </div>
                        </div>

                        <div className={styles.order_description}>
                          <div className={styles.order_description_option}>
                            BIC
                          </div>
                          <div className={styles.order_description_value}>
                            {" "}
                            DEUTDEDBMUC
                          </div>
                        </div>

                        <div className={styles.order_description}>
                          <div className={styles.order_description_option}>
                            Amount
                          </div>
                          <div className={styles.order_description_value}>
                            {" "}
                            {order.total}€
                          </div>
                        </div>

                        <div className={styles.order_description}>
                          <div className={styles.order_description_option}>
                            Reference
                          </div>
                          <div className={styles.order_description_value}>
                            #000000100000001
                          </div>
                        </div>
                      </>
                    )}
                    {order.payment_status === "paid" && (
                      <>
                        <div className={styles.order_description}>
                          <div className={styles.order_description_option}>
                            Payment method
                          </div>
                          <div className={styles.order_description_value}>
                            Credit Card
                          </div>
                        </div>

                        <div className={styles.order_description}>
                          <div className={styles.order_description_option}>
                            Amount
                          </div>
                          <div className={styles.order_description_value}>
                            {" "}
                            {order.total}€
                          </div>
                        </div>

                        <div className={styles.order_description}>
                          <div className={styles.order_description_option}>
                            Reference
                          </div>
                          <div className={styles.order_description_value}>
                            #000000100000001
                          </div>
                        </div>
                      </>
                    )}
                  </div>

                  {order.payment_status === "pending" && (
                    <div style={{ width: "100%", marginTop: 10 }}>
                      <h3
                        style={{
                          margin: 0,
                          color: "var(--color-primary)",
                          fontWeight: "700",
                        }}
                      >
                        Payment Method
                      </h3>
                      <Divider style={{ margin: "0 0 8px 0" }} />
                      <div className={styles.bank_transfer}>
                        <div className={styles.order_description_option}>
                          Invoice / Bank Transfer
                        </div>
                        <img
                          src="https://desi-fresh.b-cdn.net/components_static/Orders/bank.svg"
                          alt="bank"
                        />
                      </div>
                      <Divider style={{ margin: "8px 0" }} />

                      <div style={{ textAlign: "center" }}>
                        Thank you for choosing us for your order. We have sent
                        an email invoice for payment. Kindly check your order
                        status by visiting the orders at{" "}
                        <a
                          href="/"
                          style={{
                            color: "var(--color-primary)",
                            textDecoration: "underline",
                          }}
                        >
                          {" "}
                          www.desifresh.co{" "}
                        </a>
                      </div>
                    </div>
                  )}

                  {order.payment_status === "paid" && (
                    <div style={{ width: "100%", marginTop: 10 }}>
                      <h3
                        style={{
                          margin: 0,
                          color: "var(--color-primary)",
                          fontWeight: "700",
                        }}
                      >
                        Delivery Details
                      </h3>
                      <Divider style={{ margin: "0 0 8px 0" }} />
                      <div className={styles.order_description}>
                        <div className={styles.order_description_option}>
                          Delivered by
                        </div>
                        <div
                          className={styles.order_description_value}
                          style={{ textTransform: "uppercase" }}
                        >
                          {" "}
                          {order.delivery_method}{" "}
                        </div>
                      </div>

                      <div className={styles.order_description}>
                        <div className={styles.order_description_option}>
                          Delivered option
                        </div>
                        <div className={styles.order_description_value}>
                          Standard free delivery (3-4 days)
                        </div>
                      </div>

                      <Divider style={{ margin: "0 0 8px 0" }} />

                      <ul style={{ paddingLeft: 24 }}>
                        <li>
                          Please note that all prices incl. VAT (except shipping
                          costs).
                        </li>
                        <li>
                          You will not receive Desi Family Points for this
                          purchase.
                        </li>
                      </ul>
                    </div>
                  )}

                  <Link to={`/track-order/${id}`}>
                    <Button
                      type="primary"
                      size="large"
                      className={styles.track_order_btn}
                    >
                      <span>Track Order </span>
                      <img
                        src="https://desi-fresh.b-cdn.net/components_static/Orders/map_white.svg"
                        alt="map"
                      />
                    </Button>
                  </Link>
                </div>
              </>
            )}
          </>
        )}
      </div>
    </Layout>
  );
};

export default OrderSuccess;
